import { connect } from 'react-redux';
import { CoursesPage } from './component';
import { selectIsLoggedIn } from '../../../ReduxStorage/Auth/selectors';
import { ReduxState } from '../../../ReduxStorage/state';
import {
  selectHasFiltersSelected,
  selectTotalResults,
  selectIsProcessing,
  selectError,
  selectFeaturedCourses,
} from './selectors';
import { fetchSearchResults } from './dispatchers';
import { ConnectedCourseCardProps } from '../../components/Marketing/CourseCard/types';

export const ConnectedCoursesPage = connect(
  (state: ReduxState) => ({
    isLoggedIn: selectIsLoggedIn(state),
    hasFiltersSelected: selectHasFiltersSelected(state),
    totalResults: selectTotalResults(state),
    processing: selectIsProcessing(state),
    error: selectError(state),
    featuredCourses: selectFeaturedCourses(state) as ConnectedCourseCardProps[],
  }),
  (dispatch) => ({
    onRefreshClick: () => dispatch(fetchSearchResults()),
  })
)(CoursesPage);
